module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/f0a22c55c508d10ff16e4e5ba92e0b05.png";